module.exports = __webpack_public_path__ + "static/media/IMG-8.ca9d2d46.jpg";